import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import EmergencyBar from "@/components/EmergencyBar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Rebuild from "@/components/Rebuild";
import Testimonials from "@/components/Testimonials";
import RequestForm from "@/components/RequestForm";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#08080A] text-slate-100 antialiased" data-testid="app-root">
      <div className="grain-overlay" />
      <Hero />
      <Marquee />
      <Services />
      <Rebuild />
      <Testimonials />
      <RequestForm />
      <Footer />
      <EmergencyBar />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
